var SpinnerComponent = Vue.component('spinner-vue', {
	template: '#spinner-vue',
	props: ['hideSpinner']
});
